<template lang="pug">
f7-page#sent-curriculums
  navbar(title="送信済みカリキュラム" back)

  f7-toolbar(:bottom-md="true" class="send-curriculum")
      large-button(
        title="カリキュラムを送信する"
        class="send-curriculum-button"
        @click="onClick")

  background
    sent-curriculum-list(:studentId="studentId" @click="showDetail")
</template>

<style lang="scss" scoped>
.send-curriculum {
  height: 80px !important;
  background: none;

  .send-curriculum-button {
    margin: 24px !important;
    width: 100%;
  }
}
</style>

<script>
import PageTitle from '@/components/mixins/PageTitle'
import SentCurriculumList from '@/components/organisms/SentCurriculumList'
import LargeButton from '@/components/atoms/LargeButton'

export default {
  mixins: [PageTitle],
  title: '送信済みカリキュラム',
  components: {
    SentCurriculumList,
    LargeButton,
  },
  data() {
    return {
      studentId: null,
    }
  },
  methods: {
    onClick() {
      this.$f7router.navigate(`/students/${this.studentId}/unsent_curriculums`)
    },
    showDetail(curriculumId) {
      this.$f7router.navigate(`/curriculums/${curriculumId}/show`)
    },
  },
  created() {
    this.studentId = this.$f7route.params.studentId
  },
}
</script>
